import { render, staticRenderFns } from "./other-info.vue?vue&type=template&id=15ca0ff2&"
import script from "./other-info.vue?vue&type=script&lang=js&"
export * from "./other-info.vue?vue&type=script&lang=js&"
import style0 from "./other-info.vue?vue&type=style&index=0&id=15ca0ff2&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports